import { NewPageList } from "./new-page-list";

export class Sponsors {
    $key: string;

    name: string;
    type: string = null;

    position: number;
    
    website: string = null;
    email: string = null;
    phoneNo: string;

    linkedIn: string = null;
    twitter: string = null;
    facebook: string = null;
    instagram: string = null;

    hasDetailsPage: boolean = false;

    bannerName: string = null;
    bannerUrl: string = null;
    bannerCMId: string = null;


    aboutList = new Array<NewPageList>();

}


// WEBPACK FOOTER //
// /app/src/app/core/models/sponsors.ts